import { render, staticRenderFns } from "./area-link.vue?vue&type=template&id=269ff20e&lang=pug&"
import script from "./area-link.vue?vue&type=script&lang=js&"
export * from "./area-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports